import React from 'react';
import Instr1 from './InstructionComponents/Instr1';
import Instr2 from './InstructionComponents/Instr2';
import Instr3 from './InstructionComponents/Instr3';
import Instr4 from './InstructionComponents/Instr4';
import Instr5 from './InstructionComponents/Instr5';
import Instr6 from './InstructionComponents/Instr6';
import Instr7 from './InstructionComponents/Instr7';
import Instr8 from './InstructionComponents/Instr8';
import Instr9 from './InstructionComponents/Instr9';
import Instr10 from './InstructionComponents/Instr10';
import Instr11 from './InstructionComponents/Instr11';
import Instr12 from './InstructionComponents/Instr12';
import Instr13 from './InstructionComponents/Instr13';
import Instr14 from './InstructionComponents/Instr14';
import Instr15 from './InstructionComponents/Instr15';
import Instr16 from './InstructionComponents/Instr16';
import Instr17 from './InstructionComponents/Instr17';
import Instr18 from './InstructionComponents/Instr18';
import Instr19 from './InstructionComponents/Instr19';
import Instr20 from './InstructionComponents/Instr20';
import Instr21 from './InstructionComponents/Instr21';

const instructions = [
  {
    name: 'Електро безопасност при присъединяване на нов клиент',
    id: 1,
    instruction: <Instr1 />,
  },
  {
    name: 'Безопасност при работа с преносими стълби',
    id: 2,
    instruction: <Instr2 />,
  },
  {
    name: 'Безопасна работа по стълбове',
    id: 3,
    instruction: <Instr3 />,
  },
  {
    name:
      'Безопасна работа при строителство и поддържане на въздушни съобщителни линии и мрежи (ВСЛМ)',
    id: 4,
    instruction: <Instr4 />,
  },
  {
    name: 'Безопасна работа при обковаване на телекомуникационни кабели по стените на сградите',
    id: 5,
    instruction: <Instr5 />,
  },
  {
    name: 'Безопасна работа с ръчно ел. инструменти, преносими лампи и захранващи устройства',
    id: 6,
    instruction: <Instr6 />,
  },
  {
    name: 'Безопасна работа с пробивна машина (бормашина)',
    id: 7,
    instruction: <Instr7 />,
  },
  {
    name: 'Безопасна работа с шмиргел',
    id: 8,
    instruction: <Instr8 />,
  },
  {
    name: 'Безопасна работа с ръчни механични инструменти',
    id: 9,
    instruction: <Instr9 />,
  },
  {
    name: 'Безопасна работа при покривни работи',
    id: 10,
    instruction: <Instr10 />,
  },
  {
    name: 'Безопасна работа със стационарни и подвижни двигател-генератори/дизелагрегати',
    id: 11,
    instruction: <Instr11 />,
  },
  {
    name: 'Безопасна работа при ръчно обработване на товари',
    id: 12,
    instruction: <Instr12 />,
  },
  {
    name: 'Безопасна работа в сервизни работилници',
    id: 13,
    instruction: <Instr13 />,
  },
  {
    name:
      'Безопасна работа при екслоатация на електрически уредби, ел. съоражения и инсталации до 1000 V',
    id: 14,
    instruction: <Instr14 />,
  },
  {
    name: 'Безопасна работа по антенно-фидерни и мачтови съоръжения',
    id: 15,
    instruction: <Instr15 />,
  },
  {
    name: 'Защита на хора, работещи на открито при гръмотевични бури',
    id: 16,
    instruction: <Instr16 />,
  },
  {
    name: 'Безопасна работа с оптични кабели',
    id: 17,
    instruction: <Instr17 />,
  },
  {
    name: 'Оказване на първа долекарска помощ на пострадали при злополуки',
    id: 18,
    instruction: <Instr18 />,
  },
  {
    name: 'Използване на работно оборудване',
    id: 19,
    instruction: <Instr19 />,
  },
  {
    name: 'Инсталация на услуги',
    id: 20,
    instruction: <Instr20 />,
  },
  {
    name:
      'За ежедневен инструктаж за временна организация и безопасност на движението (ВОБД) при извършване на строителни и монтажни работи по пътищата и улиците',
    id: 21,
    instruction: <Instr21 />,
  },
];
export default instructions;
